<template>
  <div v-if="current">
    <v-row>
      <v-col cols="12" sm="6">
        <v-text-field
          label="Nome"
          solo
          v-model="query"
          @click:append="search()"
          append-icon="mdi-magnify"
          v-on:keyup.enter="search()"
          dense
          hide-details
        ></v-text-field>
      </v-col>
      <v-col cols="12" sm="4" class="d-flex align-center">
        <v-chip color="info" outlined>
          <v-icon left small>mdi-account-multiple</v-icon>
          {{ counter }} registros
        </v-chip>
      </v-col>
      <v-col cols="12" sm="2" class="d-flex align-center">
        <v-btn color="primary" @click="register()" block>+</v-btn>
      </v-col>
    </v-row>
    <v-simple-table>
      <thead>
        <tr>
          <th>Código</th>
          <th>Nome</th>
          <th>CPF/CNPJ</th>
          <th>Ações</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="item in current" :key="item.id">
          <td>{{ item.codigo }}</td>
          <td>{{ item.nome }}</td>
          <td>{{ item.cpfCnpj }}</td>
          <td>
            <v-btn icon @click="details(item)"
              ><v-icon>mdi-magnify</v-icon></v-btn
            >
          </td>
        </tr>
      </tbody>
    </v-simple-table>

    <v-pagination
      v-if="pages > 1"
      v-model="page"
      :length="pages"
      :total-visible="7"
      @input="goToPage"
      class="mt-4"
    ></v-pagination>

    <v-dialog v-model="dialog_loading" persistent width="300">
      <v-card color="primary" dark>
        <v-card-text>
          Por favor aguarde
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import api from "../../api/index.js";
import router from "../../router/index.js";
export default {
  data: () => ({
    current: null,
    counter: 0,
    query: "",
    page: 1,
    pages: 1,
    searching: false,
    dialog_loading: false,
  }),
  created: function () {
    this.load();
  },
  methods: {
    // a API retorna HAL paginado: { _embedded: { negociantes: [...] }, page: { totalElements, totalPages, number } }
    // tambem aceita um array simples como fallback
    extract: function (data) {
      data = data || {};
      var embedded = data._embedded || {};
      var items = embedded.negociantes || (Array.isArray(data) ? data : []);
      var page = data.page || {};
      return {
        items: items,
        total: page.totalElements != null ? page.totalElements : items.length,
        totalPages: page.totalPages != null ? page.totalPages : 1,
        number: page.number != null ? page.number : 0,
      };
    },
    load: function (page) {
      var me = this;
      me.searching = false;
      me.current = [];
      var token = localStorage.getItem("token");
      // v-pagination e 1-based; a API e 0-based
      var index = (page || 1) - 1;
      me.dialog_loading = true;
      api
        .get("/client", {
          headers: { Authorization: "Bearer " + token },
          params: { page: index, size: 20 },
        })
        .then(function (response) {
          me.dialog_loading = false;
          var result = me.extract(response.data);
          me.current = result.items;
          me.counter = result.total;
          me.pages = result.totalPages;
          me.page = result.number + 1;
        })
        .catch(function (error) {
          me.dialog_loading = false;
          alert("Falha ao recuperar registros!");
          console.log(error);
        });
    },
    register: function () {
      router.push({ path: `/client/0` });
    },
    details: function (item) {
      router.push({ path: `/client/${item.id}` });
    },
    search: function (page) {
      var me = this;
      if (me.query == "") {
        this.load();
        return;
      }
      me.searching = true;
      me.current = [];
      var token = localStorage.getItem("token");
      // v-pagination e 1-based; a API e 0-based
      var index = (page || 1) - 1;
      me.dialog_loading = true;
      api
        .get("/client/name/" + this.query, {
          headers: { Authorization: "Bearer " + token },
          params: { page: index, size: 20 },
        })
        .then(function (response) {
          me.dialog_loading = false;
          var result = me.extract(response.data);
          me.current = result.items;
          me.counter = result.total;
          me.pages = result.totalPages;
          me.page = result.number + 1;
        })
        .catch(function (error) {
          me.dialog_loading = false;
          console.log(error);
          alert("Falha ao buscar registros!");
        });
    },
    // a pagina ativa chama o endpoint certo conforme estamos em busca ou listagem
    goToPage: function (page) {
      if (this.searching) {
        this.search(page);
      } else {
        this.load(page);
      }
    },
    colorType: function (item) {
      var color = "default";
      if (item.type == 1) {
        color = "warning";
      } else if (item.type == 2) {
        color = "success";
      } else if (item.type == 3) {
        color = "error";
      }
      return color;
    },
  },
  filters: {
    formatType: function (item) {
      var text = "desconhecido";
      if (item.type == 1) {
        text = "Voz";
      } else if (item.type == 2) {
        text = "SMS";
      } else if (item.type == 3) {
        text = "Internet";
      }
      return text;
    },
  },
};
</script>